import React from 'react';
import { FormattedMessage } from 'react-intl';

import { FlexColumn, Gap } from 'ui-components/components/flex';
import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';
import { Text, TextType } from 'ui-components/components/text';

import { FbsApplicationDrawerSection } from '../fbs-application-drawer-section';
import { messages } from './messages';
import styles from './sku-count-section.module.less';

export const skuCountOptions = [
  { id: 'lessThan50', messageDescriptor: messages.lessThan50 },
  { id: '50-100', messageDescriptor: messages.fiftyTo100 },
  { id: '100-500', messageDescriptor: messages.oneHundredTo500 },
  { id: '500-1000', messageDescriptor: messages.fiveHundredTo1000 },
  { id: 'moreThan1000', messageDescriptor: messages.moreThan1000 },
  { id: 'unsure', messageDescriptor: messages.unsure },
];

/**
 * @param {object} props
 * @param {string} props.skuCount - The selected SKU count value
 * @param {(id: string) => void} props.onSkuCountChange - Handler for SKU count changes
 * @param {boolean} props.isComplete
 * @param {boolean} props.isEditing
 * @param {boolean} props.isDisabled
 * @param {boolean} props.isContinueDisabled
 * @param {() => void} props.onContinue
 * @param {() => void} props.onEdit
 * @returns {JSX.Element} The SKU count section component
 */
export const SkuCountSection = ({
  skuCount,
  onSkuCountChange,
  isComplete,
  isEditing,
  isDisabled,
  isContinueDisabled,
  onContinue,
  onEdit,
}) => {
  return (
    <FbsApplicationDrawerSection
      headerMessageDescriptor={messages.skuCountTitle}
      isComplete={isComplete}
      isContinueDisabled={isContinueDisabled}
      isDisabled={isDisabled}
      isEditing={isEditing}
      onContinue={onContinue}
      onEdit={onEdit}
    >
      <FlexColumn gap={Gap.Space16}>
        <Text textType={TextType.H4} value={messages.skuCountDescription} />
        <RadioCheckList className={styles['radio-options-grid']}>
          {skuCountOptions.map((option) => (
            <RadioCheckListItem
              key={option.id}
              className={styles['radio-button']}
              isChecked={skuCount === option.id}
              isDisabled={isComplete ? !isEditing : null}
              name='skuCount'
              onChecked={() => onSkuCountChange(option.id)}
              value={option.id}
            >
              <FormattedMessage {...option.messageDescriptor} />
            </RadioCheckListItem>
          ))}
        </RadioCheckList>
      </FlexColumn>
    </FbsApplicationDrawerSection>
  );
};
